module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Cursor-5c0cb4521530bf8190cfb39671b7d429.svg";